import { Theme, useMediaQuery } from '@mui/material';
import { DownloadAppCon, LeftCon } from './style';
import { Png } from '../../../assets/Png';
import { AppleStoreIcon, PlayStoreIcon } from '../../../assets/Icons';
import { Spacer } from '../../atoms';
import { Reveal } from '../../atoms/Container/Reveal';

export const DownloadApp = () => {
  const { MobileShop } = Png;
  const md = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  return (
    <DownloadAppCon bg={!md && MobileShop}>
      <LeftCon>
        <Reveal>
          {!md && (
            <p className="heading">
              Download our Mobile <br /> App today!
            </p>
          )}
        </Reveal>
        <Reveal>
          {md && (
            <p className="heading">
              Download our Mobile App <br /> today!
            </p>
          )}
        </Reveal>
        <Reveal>
          <p className="desc">
            Download the madina supermarket application to enjoy a more seamless and efficient shopping process.{' '}
          </p>
        </Reveal>
        <Spacer height={md ? '24px' : '48.41px'} />
        <div className="btns">
          <Reveal>
            <AppleStoreIcon />
          </Reveal>
          <Reveal>
            <PlayStoreIcon />
          </Reveal>
        </div>
        <Reveal>
          <div className="mobile-shop">{md && <img src={MobileShop} alt="mobile app" />}</div>
        </Reveal>
      </LeftCon>
    </DownloadAppCon>
  );
};
